module.exports = __webpack_public_path__ + "img/live-title.b63fa33a.png";